(() => {
  const selector = ".bsf-wishlist-button, .m-wishlist-button";
  const customButtonSelector = ".bsf-wishlist-button";
  const config = window.BsfWishlistConfig || {};
  const popupSelector = "[data-bsf-wishlist-login-popup]";
  const popupCloseSelector = "[data-bsf-wishlist-login-close]";
  let guestWishlistPopupLogoPreloaded = false;

  const getButton = (target) =>
    target instanceof Element ? target.closest(selector) : null;

  const redirectGuests = (event) => {
    const button = getButton(event.target);

    if (!button || config.customerLoggedIn) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    openGuestWishlistPopup();
    return true;
  };

  const getGuestWishlistPopup = () => document.querySelector(popupSelector);

  const preloadGuestWishlistPopupLogo = () => {
    if (guestWishlistPopupLogoPreloaded || config.customerLoggedIn) return;

    const popup = getGuestWishlistPopup();
    const popupLogoUrl = popup && popup.dataset.popupLogoUrl;

    if (!popupLogoUrl) return;

    const image = new Image();
    image.src = popupLogoUrl;
    guestWishlistPopupLogoPreloaded = true;
  };

  const openGuestWishlistPopup = () => {
    const popup = getGuestWishlistPopup();

    if (!popup) {
      window.location.href = config.loginUrl;
      return;
    }

    popup.classList.add("is-open");
    popup.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("prevent-scroll");
    document.documentElement.classList.add("bsf-wishlist-popup-open");
    document.body.classList.add("bsf-wishlist-popup-open");

    const closeButton = popup.querySelector(popupCloseSelector);
    closeButton && closeButton.focus();
  };

  const closeGuestWishlistPopup = () => {
    const popup = getGuestWishlistPopup();

    if (!popup || !popup.classList.contains("is-open")) return;

    popup.classList.remove("is-open");
    popup.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("prevent-scroll");
    document.documentElement.classList.remove("bsf-wishlist-popup-open");
    document.body.classList.remove("bsf-wishlist-popup-open");
  };

  const onWishlistInteraction = (event) => {
    redirectGuests(event);
  };

  const onWishlistKeydown = (event) => {
    if (event.key === "Escape") {
      closeGuestWishlistPopup();
      return;
    }

    if (event.key !== "Enter" && event.key !== " ") return;
    onWishlistInteraction(event);
  };

  const onWishlistPopupClick = (event) => {
    const closeTarget =
      event.target instanceof Element
        ? event.target.closest(popupCloseSelector)
        : null;

    if (!closeTarget) return;

    event.preventDefault();
    closeGuestWishlistPopup();
  };

  const onWishlistHover = (event) => {
    const button = getButton(event.target);

    if (!button || config.customerLoggedIn) return;

    preloadGuestWishlistPopupLogo();
  };

  const syncPdpWishlistVariant = (variant) => {
    if (!variant) return;

    document.querySelectorAll(".bsf-wishlist-button--pdp").forEach((button) => {
      button.dataset.wishlistVariantId = variant.id;
      button.dataset.wishlistProductUrl = `${window.location.pathname}?variant=${variant.id}`;

      if (variant.featured_image && variant.featured_image.src) {
        button.dataset.wishlistProductImage = variant.featured_image.src;
      }

      button.setAttribute("aria-pressed", "false");
      button.dataset.wishlisted = "false";
      button.classList.remove(
        "is-active",
        "active",
        "wishlisted",
        "added",
        "added-to-wishlist",
      );
      button.removeAttribute("data-wishlist-active");
      button.removeAttribute("data-wishlist-added");
      button.removeAttribute("data-wishlist-state");
    });
  };

  const syncPdpWishlistFromVariantInput = (event) => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || input.name !== "id") return;

    const variantId = Number(input.value);
    const productId = document.body.dataset.productId;
    const productData =
      productId && window._themeProducts && window._themeProducts[productId];
    const variant =
      productData && productData.variants
        ? productData.variants.find((item) => item.id === variantId)
        : null;

    if (variant) syncPdpWishlistVariant(variant);
  };

  const subscribeToPdpVariantChanges = () => {
    const productId = document.body.dataset.productId;

    if (
      !productId ||
      !window.MinimogEvents ||
      typeof window.MinimogEvents.subscribe !== "function"
    )
      return;

    window.MinimogEvents.subscribe(
      `${productId}__VARIANT_CHANGE`,
      syncPdpWishlistVariant,
    );
  };

  document.addEventListener("click", onWishlistInteraction, true);
  document.addEventListener("click", onWishlistPopupClick);
  document.addEventListener("pointerover", onWishlistHover, true);
  document.addEventListener("keydown", onWishlistKeydown, true);
  document.addEventListener("change", syncPdpWishlistFromVariantInput);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      subscribeToPdpVariantChanges();
    });
  } else {
    subscribeToPdpVariantChanges();
  }

  document.querySelectorAll(customButtonSelector).forEach((button) => {
    button.setAttribute("data-bsf-wishlist-managed", "true");
  });
})();
